import { useEffect } from "react";

const PAGE_TITLE = "Terms & Conditions | Accent Productions";

/**
 * Ported from web/src/app/terms/page.tsx (Next.js App Router).
 *
 * - next/metadata export -> document.title effect (SEO deferred).
 * - Pure content page, no Next-specific APIs.
 */
export default function TermsPage() {
  useEffect(() => {
    document.title = PAGE_TITLE;
  }, []);

  return (
    <div className="max-w-prose mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-8">Terms & Conditions</h1>

      <div className="space-y-10 text-gray-600">
        {/* Booking & Payment */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Booking & Payment</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Payment</h3>
              <p>A 50% deposit is required to confirm your booking. The remaining balance is due before event day. All payments are made via bank transfer.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Quote Validity</h3>
              <p>Quotes are valid for the period specified on the quote, or 28 days from issue if not specified.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Changes</h3>
              <p>Any changes to the scope of work after quote approval may incur additional charges. We will discuss these with you before proceeding.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Cancellation</h3>
              <p>Cancellations made 14 or more days before the event receive a full refund minus the deposit. Cancellations 7-14 days out receive a 50% refund. Cancellations less than 7 days before the event are non-refundable.</p>
            </section>
          </div>
        </div>

        {/* Service & Equipment */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Service & Equipment</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Scope</h3>
              <p>Your quote covers the equipment and services listed on it. Power supply, venue access, and any required resource consents are the client&apos;s responsibility.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Equipment</h3>
              <p>The client is liable for any damage to or theft of equipment during the hire period, beyond normal wear and tear.</p>
            </section>
          </div>
        </div>

        {/* Event & Venue */}
        <div>
          <h2 className="text-lg font-bold text-gray-900 mb-4 pb-2 border-b border-gray-200">Event & Venue</h2>
          <div className="space-y-6">
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Weather</h3>
              <p>For outdoor events, the client must provide a covered area for equipment. Accent Productions may refuse to set up if weather conditions risk damage to equipment.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Noise & Compliance</h3>
              <p>The client is responsible for noise management and compliance with council regulations at the event.</p>
            </section>
            <section>
              <h3 className="text-base font-semibold text-gray-900 mb-1">Force Majeure</h3>
              <p>Neither party is liable for failure to perform obligations due to events beyond reasonable control, including natural disasters, pandemics, or government restrictions.</p>
            </section>
          </div>
        </div>

        <p className="text-sm text-gray-400 pt-4">Last updated: April 2026</p>
      </div>
    </div>
  );
}
